<template lang="pug">
  Auth(@loggedIn="onLoggedIn" @loginFailed="onFailedAuthentication")
    Header(:content="headerContent")
    div.wrap-add-course.f.fh
      ModuleAddCourse(v-if="uid")

</template>

<style lang="scss" scoped>
.wrap-add-course {
  width: 100%;
  min-height: 100vh;
}
</style>

<script>
import db from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import Auth from '@/components/auth'
import Header from '@/components/shared/Header.vue'
import ModuleAddCourse from '@/components/module/ModuleAddCourse'

export default {
  components: {
    Auth,
    Header,
    ModuleAddCourse
  },
  data () {
    return {
      headerContent: {
        label: '',
        leftAction: {
          icon: 'person',
          color: '#fff',
          method: this.toMyPage
        },
        rightActions: [
          {
            icon: 'settings',
            color: '#fff',
            method: this.toSettings
          }
        ]
      }
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  methods: {
    onFailedAuthentication () {
      this.$router.push('/sign-in')
    },
    onLoggedIn () {
    
    },
    onHeaderRight () {

    },
    toMyPage () {
      this.$router.push(`/users/${this.uid}`)
    },
    toSettings () {
      this.$router.push('/settings')
    }
  }
}
</script>
